import "./Menu.css";
import { TransparantIcon } from "../Button/IconButton";

export const Menu = ({ selectedKey, menuItems }) => {
  return (
    <div className="position-relative" style={{ zIndex: "10" }}>
      <div className="align-nav">
        {menuItems.map((item) => {
          return (
            <div
              key={item.menuName}
              onClick={item.onClickMenuItem}
              className={`nav-anchor ${
                selectedKey === item.menuName ? "selected-nav" : ""
              }`}
            >
              <div className="nav-component">
                {selectedKey === item.menuName ? (
                  <TransparantIcon
                    className={`desktop-display-none ${
                      item.className ? item.className : ""
                    }`}
                  >
                    <img src={item.menuSelectedIcon} alt={item.menuName}></img>
                  </TransparantIcon>
                ) : (
                  <TransparantIcon
                    className={`desktop-display-none ${
                      item.className ? item.className : ""
                    }`}
                  >
                    <img src={item.menuIcon} alt={item.menuName}></img>
                  </TransparantIcon>
                )}
                <span
                  className={`nav-text ${
                    selectedKey === item.menuName ? "color-change-nav" : ""
                  }`}
                >
                  {item.menuName}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
